import React, { useRef } from 'react';
import PlatformSection from '../PlatformSection';
import TestimonialSection from '../TestimonialSection';
import { HomepagePlatformSection } from '@/shared/types/homepage';
import { motion } from 'framer-motion';
import './index.less';

interface IProps {
  section: HomepagePlatformSection;
}

const TabSection = ({ section }: IProps) => {
  const ref = useRef<HTMLDivElement | null>(null);

  return (
    <motion.div
      ref={ref}
      id={section.id}
      className="tab-section"
      animate={{ opacity: 1, y: 0 }}
      initial={{ opacity: 0, y: 20 }}
      transition={{ duration: 0.5, ease: 'easeInOut' }}
    >
      <PlatformSection section={section} />
      {section.testimonial && <TestimonialSection testimonial={section.testimonial} />}
    </motion.div>
  );
};

export default TabSection;
